import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

import { DOCUMENT_CONTENT_REPLACED_META } from './ExplicitContentSelection';

/** On the editor root until the document content first arrives; the styling lives in `_content-large-document.scss`. */
export const INITIAL_CONTENT_CLASS = 'initial-content';

const initialContentMarkerKey = new PluginKey<boolean>('initialContentMarker');

const InitialContentMarker = Extension.create({
  name: 'initialContentMarker',

  addProseMirrorPlugins() {
    return [
      new Plugin<boolean>({
        key: initialContentMarkerKey,
        state: {
          init: () => true,
          apply: (transaction, isInitial) => isInitial && !transaction.getMeta(DOCUMENT_CONTENT_REPLACED_META),
        },
        props: {
          attributes: (state): Record<string, string> =>
            initialContentMarkerKey.getState(state) ? { class: INITIAL_CONTENT_CLASS } : {},
        },
      }),
    ];
  },
});

export default InitialContentMarker;
